export const GET_PROBLEM_SUCCESS = "GET_PROBLEM_SUCCESS";
export const GET_PROBLEM_ERROR = "GET_PROBLEM_ERROR";
export const ADD_NEW_PROBLEM = "ADD_NEW_PROBLEM";
export const ADD_LIST_PROBLEM_FROM_SERVER = "ADD_LIST_PROBLEM_FROM_SERVER";
